module.exports = "<div class=articlesProfile ng-cloak> <md-card> <rkc-articles-profile-table table-definition=c.tableDefinition articles=c.searchResult></rkc-articles-profile-table> </md-card> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/main/views/articleProfile/articlesProfile.html
 ** module id = 485
 ** module chunks = 0
 **/